import http from '@/http-common.js'

class OrgpolicyService {
  basePathApiService = '/book-orgpolicy'
  getAll(params) {
    return http.get(this.basePathApiService, params)
  }
  create(createData) {
    return http.post(this.basePathApiService, createData)
  }
  editOne(id, editData) {
    return http.patch(this.basePathApiService + `/${id}`, editData)
  }
  editMultiple(id, editData) {
    return http.put(this.basePathApiService + `/${id}`, editData)
  }
  delete(id) {
    return http.delete(this.basePathApiService + `/${id}`)
  }

  downloadFile(id) {
    return http.get(this.basePathApiService + `/${id}/download-file`)
  }

  deleteFile(id) {
    return http.delete(this.basePathApiService + `/${id}/file`)
  }
}
export default new OrgpolicyService()
